function base64ToArrayBuffer(base64) {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);

  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }

  return bytes.buffer;
}

function arrayBufferToBase64(buffer) {
  const bytes = new Uint8Array(buffer);
  let binary = '';

  for (let b of bytes) {
    binary += String.fromCharCode(b);
  }

  return btoa(binary);
}

export async function verifyPBKDF2(password, storedHash) {
  try {
    const parts = storedHash.split('$');

    const iterations = parseInt(parts[1]);
    const salt = parts[2];
    const hash = parts[3];

    const encoder = new TextEncoder();

    const keyMaterial = await crypto.subtle.importKey(
      "raw",
      encoder.encode(password),
      "PBKDF2",
      false,
      ["deriveBits"]
    );

    const derivedBits = await crypto.subtle.deriveBits(
      {
        name: "PBKDF2",
        salt: encoder.encode(salt),
        iterations,
        hash: "SHA-256",
      },
      keyMaterial,
      256
    );

    const derivedHash = arrayBufferToBase64(derivedBits);

    return derivedHash === hash;
  } catch (err) {
    console.error("Hash verification failed", err);
    return false;
  }
}
